//CONTENT_GRID_JSON

import { BASIC_TEXT, CONTENT_SEARCH, IMAGE, TEXT } from "./widgetTypes"

export const Image = {
  actions: null,
  capabilities: null,
  content: {
    contentType: "image/png",
    height: 426,
    id: "62ed9afec06217066ce04d20",
    name: "dog-modified.png",
    type: "image",
    url: "5c5bdfe646e0fb0001fb3552/images/62ed9afec06217066ce04d20/cd1e7009-5188-4567-b238-3cfe0e8371ba",
    width: 426,
  },
  fonts: null,
  id: "62c7cb6787bbb85ab6e19b19",
  name: "Image",
  order: 1,
  parent: "widget_SfVs0utv",
  properties: {
    desktop: {
      alt: null,
      crop: null,
      layout: { transform: { translate: "16px,10px", rotate: "0deg", scale: "1,1" }, position: 'relative', width: "215px", height: "215px" },
      height: "215px",
      transform: { translate: "16px,10px", rotate: "0deg", scale: "1,1" },
      width: "293px",
      visible: true
    },
    mobile: {
      alt: null,
      crop: null,
      layout: { transform: { translate: "20px, 60px", rotate: "0deg" }, width: "300px", height: "300px" },
      height: "300px",
      transform: { translate: "20px, 60px", rotate: "0deg" },
      rotate: "0deg",
      translate: "20px, 60px",
      width: "300px",
      visible: true
    },
  },
  type: "cleverstory.v2.widgets.image",
  uid: "widget_m5FYrpErho"
}
export const SearchWidgetRequset = {
  type: CONTENT_SEARCH,
  name: "SearchContainer",
  properties: {
    desktop: {
      visible: true,
      layout: {
        transform: {
          rotate: "0deg"
        },
        width: "376px",
        height: "auto"
      },
      padding: 5,
      placeholder: 'Search',
      inputTextColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 1,
        type: 'solid'
      },
      searchIconColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 1,
        type: 'solid'
      },
      placeholderColor: {
        r: 245,
        g: 245,
        b: 245,
        a: 1,
        type: 'solid'
      },
      background: {
        r: 224,
        g: 224,
        b: 224,
        a: 1,
        type: 'solid'
      },
      font: {
        color: {
          r: 33,
          g: 33,
          b: 33,
          a: 1,
          type: 'solid'
        },
        style: {
          bold: false,
          italic: false,
          undeline: false
        },
        fontSize: '14'
      },
      border: {
        sides: null,
        color: {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
          type: 'solid'
        },
        width: 0,
        radius: null,
        style: 'all'
      },
      horizontalAlignment: {
        position: "center",
        margin: null
      },
      buttonStyles: {
        regular: {
          background: {
            r: 117,
            g: 117,
            b: 117,
            a: 1,
            type: 'solid'
          },
          font: {
            color: {
              r: 255,
              g: 255,
              b: 255,
              a: 1,
              type: 'solid'
            },
            style: {
              bold: false,
              italic: false,
              undeline: false
            },
            fontSize: '14'
          },
          border: {
            color: {
              r: 255,
              g: 255,
              b: 255,
              a: 1,
              type: 'solid'
            },
            width: 0,
            radius: {
              locked: true,
              topLeft: 0,
              topRight: 0,
              bottomLeft: 0,
              bottomRight: 0
            },
            style: 'all'
          },
          shadow: {
            color: {
              r: 255,
              g: 255,
              b: 255,
              a: 1,
              type: "solid"
            },
            axes: {
              x: 0,
              y: 0,
              b: 0
            },
            show: false
          }
        },
        hover: {
          background: {
            r: 117,
            g: 117,
            b: 117,
            a: 1,
            type: 'solid'
          },
          font: {
            color: {
              r: 255,
              g: 255,
              b: 255,
              a: 1,
              type: 'solid'
            },
            style: {
              bold: false,
              italic: false,
              undeline: false
            },
            fontSize: '14'
          },
          border: {
            color: {
              r: 255,
              g: 255,
              b: 255,
              a: 1,
              type: 'solid'
            },
            width: 0,
            radius: {
              locked: true,
              topLeft: 0,
              topRight: 0,
              bottomLeft: 0,
              bottomRight: 0
            },
            style: 'all'
          },
          shadow: {
            color: {
              r: 255,
              g: 255,
              b: 255,
              a: 1,
              type: "solid"
            },
            axes: {
              x: 0,
              y: 0,
              b: 0
            },
            show: false
          }
        }
      }
    },
    mobile: {
      visible: true,
      layout: {
        transform: {
          rotate: "0deg"
        },
        width: "100%",
        height: "auto"
      },
    }
  },
  content: ''
}

export const countTextWidgetRequest = {
  name: "Text",
  type: BASIC_TEXT,
  name: "Text",
  order: 2, 
  systemDefined: false, 
  fonts: null,
  actions: null,
  parameter: "Text",
  properties: {
    desktop: {
      visible: true,
      layout: {
        transform: {
          translate: "0px, 0px",
          rotate: "0deg", 
        },
        width: "fit-content",
        height: "17px" 
      },
      font: {
        style: null,
        fontSize: '14px', 
        fontFamily: "Montserrat,sans-serif",
        lineSpacing: 1.2, 
        letterSpacing: 0, 
        color: null
      },
      alignment: "left",
      background: null,
      animation: null
    },
    mobile: {
      visible: true,
      layout: {
        transform: {
          translate: "0px, 0px",
          rotate: "0deg", 
        },
        width: "fit-content",
        height: "17px" 
      },
      font: {
        style: null,
        fontSize: 14, 
        fontFamily: null,
        lineSpacing: 1.2, 
        letterSpacing: 0, 
        color: null
      },
      alignment: "left",
      background: null,
      animation: null
    }
  },
  content: "Showing 0-0 of 0 Assets"
};

export const CONTENT_GRID_CARDS =

  [{
    widgets: [Image],
    assetType: 'LINK',
    asset: '<a>test</a>'
  },
  {
    widgets: [Image],
    assetType: 'LINK',
    asset: '<a>test</a>'
  },
  {
    widgets: [Image],
    assetType: 'LINK',
    asset: '<a>test</a>'
  },
  {
    widgets: [Image],
    assetType: 'LINK',
    asset: '<a>test</a>'
  },
  {
    widgets: [Image],
    assetType: 'LINK',
    asset: '<a>test</a>'
  },
  {
    widgets: [Image],
    assetType: 'LINK',
    asset: '<a>test</a>'
  },
  {
    widgets: [Image],
    assetType: 'LINK',
    asset: '<a>test</a>'
  },

  ]

export const getLayoutStyle = (type) => {

  switch (type) {
    case 'grid':
      return {
        type: "grid",
        name: 'grid',
        rowGap: 2,
        columnGap: 2,

      }
    case 'metro':
      return {
        type: "metro",
        name: 'metro',
      }
  }
}

export const fieldsTypes = [{
  parameter: 'name',
  name: 'Name',
  widgetConfig: {
    type: BASIC_TEXT,
    width: 260,
    height: 24
  }
}, {
  parameter: 'description',
  name: 'Description',
  widgetConfig: {
    type: BASIC_TEXT,
    width: 260,
    height: 50
  }
}, {
  parameter: 'icon',
  name: 'Thumbnail',
  widgetConfig: {
    type: IMAGE,
    width: 300,
    height: 300
  }
}, {
  parameter: 'contentType',
  name: 'Type',
  widgetConfig: {
    type: BASIC_TEXT,
    width: 260,
    height: 24
  }
}, {
  parameter: 'author',
  name: 'Author',
  widgetConfig: {
    type: BASIC_TEXT,
    width: 260,
    height: 24
  }
}];